var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import _ from 'lodash';
import uniqid from 'uniqid';
import { v4 } from 'uuid';
import { createPlugin } from './createPlugin';
import { getPluginInstanceFrom } from './Fct';
import { getOutputValues } from './Fct.getOutputValues';
import { FctTradingGraphProps } from './generics';
var updateId = uniqid();
var PluginsModule = /** @class */ (function () {
    function PluginsModule(_a) {
        var chainId = _a.chainId;
        var _this = this;
        this._plugins = new Map();
        this.getOutputValues = function (testProvider) { return __awaiter(_this, void 0, void 0, function () {
            var getPluginOutputs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.startNodeIn) {
                            return [2 /*return*/, {}];
                        }
                        getPluginOutputs = function (nodeId) { return __awaiter(_this, void 0, void 0, function () {
                            var plugin, e_1, errorMessage;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!nodeId)
                                            return [2 /*return*/, {}];
                                        plugin = this.getPlugin(nodeId);
                                        if (!plugin || !plugin.plugin) {
                                            console.error("plugin nodeId: ".concat(nodeId, " not found"));
                                            return [2 /*return*/, {}];
                                        }
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 4, , 6]);
                                        return [4 /*yield*/, getOutputValues({
                                                plugin: plugin.plugin,
                                                provider: testProvider.provider,
                                                execute: testProvider.execute,
                                            })];
                                    case 2:
                                        _a.sent();
                                        this._error = undefined;
                                        if (!plugin.options.jumpOnSuccess) {
                                            return [2 /*return*/, {}];
                                        }
                                        return [4 /*yield*/, getPluginOutputs(plugin.options.jumpOnSuccess)];
                                    case 3: return [2 /*return*/, _a.sent()];
                                    case 4:
                                        e_1 = _a.sent();
                                        errorMessage = "Plugin: ".concat(plugin.nodeId, "_").concat(plugin.plugin.protocol, "_").concat(plugin.plugin.name, " error: ").concat(e_1.message);
                                        console.error(errorMessage);
                                        this._error = errorMessage;
                                        if (this.onChange)
                                            this.onChange(undefined, {
                                                nodeId: plugin.nodeId,
                                                error: errorMessage,
                                            });
                                        if (!plugin.options.jumpOnFail) {
                                            return [2 /*return*/, {}];
                                        }
                                        return [4 /*yield*/, getPluginOutputs(plugin.options.jumpOnFail)];
                                    case 5: return [2 /*return*/, _a.sent()];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        }); };
                        return [4 /*yield*/, getPluginOutputs(this.startNodeIn)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.clear = function () { return _this._plugins.clear(); };
        this.create = function () { };
        this.upsertPlugin = function (pluginNodeJSON) {
            if (!_this.chainId) {
                console.error("chainId error: set chainId");
                return;
            }
            var plugin = _this.jsonToPlugin(pluginNodeJSON.plugin, _this.chainId);
            if (!plugin) {
                console.error('plugin error');
                return;
            }
            var pluginNode = __assign(__assign({}, pluginNodeJSON), { plugin: plugin });
            _this._plugins.set(pluginNode.nodeId, pluginNode);
            _this.subscribeOnUpdate();
            _this.updateVariablesSubsciptions();
            return _this.plugins;
        };
        this.setPlugin = function (nodeId, plugin) {
            return _this.plugins.set(nodeId, plugin);
        };
        this.getPlugin = function (nodeId) {
            return _this.plugins.get(nodeId);
        };
        this.removePlugin = function (nodeId) {
            return _this.plugins.delete(nodeId);
        };
        this.generateName = function () {
            var name = 'Module.';
            _this.pluginsList.forEach(function (pluginContainer, index, list) {
                var plugin = pluginContainer.plugin;
                name += "".concat(plugin.name).concat(index < list.length - 1 ? '.' : '');
            });
            return name;
        };
        this.toJSON = function () {
            var data = {};
            _this.pluginsList.forEach(function (pluginContainer, index, list) {
                var plugin = pluginContainer.plugin, rest = __rest(pluginContainer, ["plugin"]);
                data[rest.nodeId] = __assign({ plugin: plugin.toJSON() }, rest);
            });
            return JSON.stringify({
                data: data,
                startNodeId: _this.startNodeIn,
                name: _this.name,
                type: 'MODULE',
                method: 'MODULE',
            });
        };
        this.fromJSONWithMeta = function (moduleJson) {
            try {
                var module_1 = JSON.parse(moduleJson);
                var data_1 = module_1.data, startNodeId = module_1.startNodeId, name_1 = module_1.name;
                _this._name = name_1;
                if (!data_1)
                    return false;
                if (startNodeId)
                    _this.setStartNodeIn(startNodeId);
                Object.keys(data_1).forEach(function (key) {
                    var pluginContainer = data_1[key];
                    var plugin = pluginContainer.plugin, rest = __rest(pluginContainer, ["plugin"]);
                    _this.upsertPlugin(__assign({ plugin: plugin }, rest));
                });
            }
            catch (e) {
                console.error(e);
            }
            return true;
        };
        this.jsonToPlugin = function (plugin, chainId) {
            var _a;
            return (_a = getPluginInstanceFrom({ json: plugin, chainId: chainId })) === null || _a === void 0 ? void 0 : _a.instance;
        };
        this.subscribe = function (_a) {
            var callback = _a.callback, id = _a.id;
            _this.observers.set(id, callback);
        };
        this.unsubscribe = function (_a) {
            var id = _a.id;
            _this.observers.delete(id);
        };
        this.observers = new Map();
        this.subscribeOnUpdate = function () {
            _this.observers.forEach(function (callback, id) {
                var subscribeId = id;
                _this.inputs.forEach(function (input) {
                    input.param.unsubscribe({ id: subscribeId });
                    input.param.subscribe({
                        id: subscribeId,
                        callback: function (_a) {
                            var value = _a.value;
                            return callback({ value: value, key: input.key, nodeId: input.nodeId });
                        },
                    });
                });
            });
        };
        this.updateVariablesSubsciptions = function () {
            _this.pluginsList.forEach(function (plugin) {
                if (!plugin.outputVariables)
                    return;
                plugin.outputVariables.forEach(function (subscription) { return __awaiter(_this, void 0, void 0, function () {
                    var fromNodeId, fromParamKey, toParamKey, fromPlugin, paramFromList, paramFrom, paramToList, paramTo;
                    return __generator(this, function (_a) {
                        fromNodeId = subscription.fromNodeId, fromParamKey = subscription.fromParamKey, toParamKey = subscription.toParamKey;
                        fromPlugin = this.getPlugin(fromNodeId);
                        if (!fromPlugin)
                            return [2 /*return*/];
                        paramFromList = fromPlugin.plugin.output.paramsList;
                        paramFrom = paramFromList.find(function (param) { return param.key === fromParamKey; });
                        paramToList = plugin.plugin.input.paramsList;
                        paramTo = paramToList.find(function (param) { return param.key === toParamKey; });
                        if (!paramFrom || !paramTo)
                            return [2 /*return*/];
                        paramTo.param.setString({
                            value: paramFrom.param.getOutputVariable(fromPlugin.nodeId),
                        });
                        return [2 /*return*/];
                    });
                }); });
            });
        };
        this.onUpdate = function (event) {
            _this.pluginsList.forEach(function (plugin) {
                if (!plugin.subscriptions)
                    return;
                plugin.subscriptions.forEach(function (subscription) { return __awaiter(_this, void 0, void 0, function () {
                    var fromNodeId, fromParamKey, toParamKey, fromPlugin, paramFromList, paramFrom, paramToList, paramTo, value;
                    return __generator(this, function (_a) {
                        fromNodeId = subscription.fromNodeId, fromParamKey = subscription.fromParamKey, toParamKey = subscription.toParamKey;
                        fromPlugin = this.getPlugin(fromNodeId);
                        if (subscription.fromParamKey !== event.key)
                            return [2 /*return*/];
                        if (subscription.fromNodeId !== event.nodeId)
                            return [2 /*return*/];
                        if (!fromPlugin)
                            return [2 /*return*/];
                        paramFromList = fromPlugin.plugin.input.paramsList;
                        paramFrom = paramFromList.find(function (param) { return param.key === fromParamKey; });
                        paramToList = plugin.plugin.input.paramsList;
                        paramTo = paramToList.find(function (param) { return param.key === toParamKey; });
                        if (paramFrom && paramTo && !(paramTo.param instanceof FctTradingGraphProps)) {
                            value = paramFrom.param.value;
                            paramTo.param.set({ value: value });
                            if (this.onChange) {
                                this.onChange({ nodeId: plugin.nodeId, key: subscription.toParamKey, value: value });
                            }
                        }
                        return [2 /*return*/];
                    });
                }); });
            });
        };
        this._chainId = chainId;
        this.subscribe({ callback: this.onUpdate, id: updateId });
    }
    Object.defineProperty(PluginsModule.prototype, "type", {
        get: function () {
            return 'MODULE';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "protocol", {
        get: function () {
            return 'MODULE';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "chainId", {
        get: function () {
            return this._chainId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "plugins", {
        get: function () {
            return this._plugins;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "pluginsList", {
        get: function () {
            var _this = this;
            var plugins = [];
            if (!this.startNodeIn) {
                return [];
            }
            var setPlugin = function (nodeId) {
                if (!nodeId)
                    return;
                var plugin = _this.getPlugin(nodeId);
                if (!plugin) {
                    console.error("plugin nodeId: ".concat(nodeId, " not found"));
                    return;
                }
                plugins.push(plugin);
                setPlugin(plugin.options.jumpOnSuccess);
                setPlugin(plugin.options.jumpOnFail);
            };
            setPlugin(this.startNodeIn);
            return plugins;
        },
        enumerable: false,
        configurable: true
    });
    PluginsModule.prototype.createNewModule = function (initNodeId) {
        var _this = this;
        //const plugins: PluginNode[] = []
        var prevIds = new Map();
        if (!this.startNodeIn) {
            return;
        }
        var changePluginId = function (newId, prevId) {
            var _a, _b;
            if (!prevId)
                return;
            prevIds.set(prevId, newId);
            var plugin = _this.getPlugin(prevId);
            if (!plugin) {
                console.error("plugin nodeId: ".concat(prevId, " not found"));
                return;
            }
            _this.removePlugin(prevId);
            plugin.nodeId = newId;
            _this.setPlugin(newId, plugin);
            var subs = (_a = plugin.subscriptions) === null || _a === void 0 ? void 0 : _a.map(function (subscription) {
                var newIdFromPrevId = prevIds.get(subscription.fromNodeId);
                if (!newIdFromPrevId)
                    return subscription;
                subscription.fromNodeId = newIdFromPrevId;
                return subscription;
            });
            plugin.subscriptions = subs;
            var outputSubs = (_b = plugin.outputVariables) === null || _b === void 0 ? void 0 : _b.map(function (subscription) {
                var newIdFromPrevId = prevIds.get(subscription.fromNodeId);
                if (!newIdFromPrevId)
                    return subscription;
                subscription.fromNodeId = newIdFromPrevId;
                return subscription;
            });
            plugin.outputVariables = outputSubs;
            if (plugin.options.jumpOnSuccess) {
                var prevId_1 = plugin.options.jumpOnSuccess;
                var newId_1 = v4();
                plugin.options.jumpOnSuccess = newId_1;
                changePluginId(newId_1, prevId_1);
            }
            if (plugin.options.jumpOnFail) {
                var prevId_2 = plugin.options.jumpOnFail;
                var newId_2 = v4();
                plugin.options.jumpOnFail = newId_2;
                changePluginId(newId_2, prevId_2);
            }
        };
        var prevId = this.startNodeIn;
        var newId = initNodeId || v4();
        this.setStartNodeIn(newId);
        changePluginId(newId, prevId);
        var json = this.toJSON();
        this.fromJSONWithMeta(json);
        this.subscribeOnUpdate();
        this.updateVariablesSubsciptions();
    };
    PluginsModule.prototype.getInterface = function (_a) {
        var chainId = _a.chainId, initModuleJSON = _a.initModuleJSON, startNodeId = _a.startNodeId;
        var json;
        if (!initModuleJSON) {
            this.createNewModule(startNodeId);
            json = this.toJSON();
        }
        else {
            json = initModuleJSON;
        }
        var newModule = new PluginsModule({ chainId: chainId });
        newModule.fromJSONWithMeta(json);
        if (!newModule.startNodeIn)
            return;
        var initPlugin = newModule.getPlugin(newModule.startNodeIn);
        if (!initPlugin)
            return;
        var newInputValues = {};
        var newOutputValues = {};
        newModule.input.paramsList.forEach(function (param) {
            param.param.nodeId = param.nodeId;
            _.set(newInputValues, param.id, param.param);
        });
        newModule.output.paramsList.forEach(function (param) {
            param.param.nodeId = param.nodeId;
            _.set(newOutputValues, param.id, param.param);
        });
        var Plugin = createPlugin({
            protocol: newModule.protocol,
            type: 'MODULE',
            name: newModule.name,
            method: 'module',
            getParams: function () { return ({
                input: newInputValues,
                output: newOutputValues,
            }); },
        });
        var newPlugin = new Plugin({ chainId: chainId });
        newPlugin.getOutputValues = newModule.getOutputValues;
        return {
            instance: newPlugin,
            moduleInstance: newModule,
        };
    };
    Object.defineProperty(PluginsModule.prototype, "input", {
        get: function () {
            return {
                paramsList: this.inputs,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "output", {
        get: function () {
            return {
                paramsList: this.outputs,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "inputs", {
        get: function () {
            var _this = this;
            var inputs = [];
            this.plugins.forEach(function (plugin) {
                var params = plugin.plugin.input.paramsList;
                params.forEach(function (_a) {
                    var _b, _c;
                    var param = _a.param, key = _a.key;
                    var id = key === "to" ? 'to' : "".concat(key, "_").concat(plugin.nodeId);
                    param.label = param.label || key.replace('methodParams.', '');
                    param.description = "".concat(plugin.plugin.name, "_").concat(param.key);
                    if (plugin.nodeId === _this.startNodeIn) {
                        inputs.push({ param: param, key: key, nodeId: plugin.nodeId, id: id });
                        return;
                    }
                    if (!plugin.subscriptions && !plugin.outputVariables) {
                        inputs.push({ param: param, key: key, nodeId: plugin.nodeId, id: id });
                        return;
                    }
                    if (!((_b = plugin.subscriptions) === null || _b === void 0 ? void 0 : _b.find(function (subscription) {
                        return subscription.toParamKey === key;
                    })) &&
                        !((_c = plugin.outputVariables) === null || _c === void 0 ? void 0 : _c.find(function (subscription) {
                            return subscription.toParamKey === key;
                        }))) {
                        inputs.push({ param: param, key: key, nodeId: plugin.nodeId, id: id });
                        return;
                    }
                    param.hidden = true;
                    inputs.push({ param: param, key: key, nodeId: plugin.nodeId, id: id });
                });
            });
            return inputs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "outputs", {
        get: function () {
            var outputs = [];
            this.plugins.forEach(function (plugin) {
                var params = plugin.plugin.output.paramsList;
                params.forEach(function (_a) {
                    var key = _a.key, param = _a.param;
                    var id = "".concat(key, "_").concat(plugin.nodeId);
                    param.label = param.label || key;
                    param.description = "".concat(plugin.plugin.name, "_").concat(key);
                    outputs.push({
                        key: key,
                        param: param,
                        nodeId: plugin.nodeId,
                        id: id,
                    });
                });
            });
            return outputs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginsModule.prototype, "startNodeIn", {
        get: function () {
            return this._startNodeIn;
        },
        enumerable: false,
        configurable: true
    });
    PluginsModule.prototype.setStartNodeIn = function (nodeId) {
        this._startNodeIn = nodeId;
    };
    Object.defineProperty(PluginsModule.prototype, "name", {
        get: function () {
            return this._name || this.generateName();
        },
        set: function (name) {
            this._name = name;
        },
        enumerable: false,
        configurable: true
    });
    return PluginsModule;
}());
export { PluginsModule };
